import { useState, type FormEvent } from 'react';
import { KeyRound } from 'lucide-react';
import { useAuth } from '../lib/auth';
import { api } from '../lib/api';
import { Banner, Button, Field, Input, useUi } from '../components/ui';

/** Passwort ändern. `forced`: Vollbild nach Erst-Anmeldung/Zurücksetzen. */
export default function ChangePassword({ forced, onDone }: { forced?: boolean; onDone?: () => void }) {
  const { refresh, logout } = useAuth();
  const { toast } = useUi();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [repeat, setRepeat] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    if (next !== repeat) return setError('Die neuen Passwörter stimmen nicht überein.');
    setBusy(true);
    try {
      await api.post('/auth/change-password', { currentPassword: current, newPassword: next });
      toast('Passwort geändert', 'success');
      setCurrent(''); setNext(''); setRepeat('');
      await refresh();
      onDone?.();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Fehler');
    } finally {
      setBusy(false);
    }
  }

  const form = (
    <form className="stack" onSubmit={submit}>
      {forced && <Banner tone="info">Bitte lege jetzt ein eigenes Passwort fest (mindestens 8 Zeichen).</Banner>}
      {error && <Banner tone="crit">{error}</Banner>}
      <Field label={forced ? 'Startpasswort' : 'Aktuelles Passwort'}><Input type="password" autoComplete="current-password" value={current} onChange={(e) => setCurrent(e.target.value)} required /></Field>
      <Field label="Neues Passwort" hint="Mindestens 8 Zeichen, nicht nur Ziffern."><Input type="password" autoComplete="new-password" value={next} onChange={(e) => setNext(e.target.value)} required /></Field>
      <Field label="Neues Passwort wiederholen"><Input type="password" autoComplete="new-password" value={repeat} onChange={(e) => setRepeat(e.target.value)} required /></Field>
      <Button type="submit" variant="primary" loading={busy} icon={<KeyRound size={16} />}>Passwort speichern</Button>
      {forced && <Button variant="ghost" onClick={() => void logout()}>Abmelden</Button>}
    </form>
  );

  if (!forced) return form;
  return (
    <div className="auth-page">
      <div className="auth-card stack loose">
        <h1>Neues Passwort festlegen</h1>
        {form}
      </div>
    </div>
  );
}
